import { useQuery } from "@tanstack/react-query";
import { member } from "./query";
import {
  BatchModelForDropdown,
  IMemberGridFilter,
  SpecializationModelForDropdown,
} from "./types";
import { PostModel } from "common/models/baseModel";

export function GetMembers(model: PostModel<IMemberGridFilter>) {
  return useQuery(member.list(model));
}

export function useGetQuery(memberID: number) {
  return useQuery({
    ...member.get(memberID),
    enabled: memberID > 0,
  });
}

export function View(memberID: number) {
  return useQuery(member.view(memberID));
}

export function GetPendingMembers(model: PostModel<IMemberGridFilter>) {
  return useQuery(member.pendingMembers(model));
}

export function useSpecializationRoleValue(
  model: SpecializationModelForDropdown
) {
  return useQuery({
    ...member.useSpecializationRoleValue(model),
    enabled: model !== undefined && model.courseID > 0 && model.instituteID > 0,
  });
}

export function useBatchRoleValue(model: BatchModelForDropdown) {
  return useQuery({
    ...member.useBatchRoleValue(model),
    enabled:
      model !== undefined &&
      model.courseID > 0 &&
      model.instituteID > 0 &&
      model.specializationID > 0,
  });
}

export function useSkillsValue(inputValue: string | null, id: string | null) {
  return useQuery({
    ...member.useSkillsValue(inputValue!, id!),
  });
}

export function useProgrambyCommunityValue() {
  return useQuery({
    ...member.useProgrambyCommunityValue(),
  });
}

// export function ApproveMember(model: IMember) {
//   return useQuery(member.approveMember(model));
// }

// export function RejectMember(model: IMember) {
//   return useMutation();
// }
